//import React from "react";

import React, { useState } from "react";

/// React router dom
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import InstituteRegistration from "./pages/InstituteRegisteration";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import ForgotPassword from "./pages/ForgotPassword";
/// Widget
import Widget from "./pages/Widget";

/// Deshboard
import Home from "./components/Dashboard/Home/Home";
/* import Companies from "./components/Dashboard/Companies/Companies";
import Analytics from "./components/Dashboard/Analytics/Analytics";
import Review from "./components/Dashboard/Review/Review";
import Order from "./components/Dashboard/Order/Order";
import Orderlist from "./components/Dashboard/Orderlist/Orderlist";
import Customerlist from "./components/Dashboard/Customerlist/Customerlist"; */
import Messages from "./components/Dashboard/Messages/Messages";
import Contacts from "./components/Dashboard/Contacts/Contacts";
import Kanban from "./components/Dashboard/Kanban/Kanban";
import Projects from "./components/Dashboard/Projects/Projects";
import Calendarpage from "./components/Dashboard/Calendarpage/Calendarpage";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiMediaObject from "./components/bootstrap/MediaObject";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import InstituteProfile from "./components/AppsMenu/AppProfile/InstituteProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Chart
import SparklineChart from "./components/charts/Sparkline";
import ChartFloat from "./components/charts/chartflot/index";
import ChartJs from "./components/charts/Chartjs";
import Chartist from "./components/charts/chartist";
import RechartJs from "./components/charts/rechart";
import BtcChart from "./components/charts/apexcharts/ApexChart";
import ApexChart from "./components/charts/apexcharts";

/// Table
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import SummerNote from "./components/Forms/Summernote/SummerNote";
import Pickers from "./components/Forms/Pickers/Pickers";
import jQueryValidation from "./components/Forms/jQueryValidation/jQueryValidation";

/// Pulgin
import Select2 from "./components/PluginsMenu/Select2/Select2";
import Nestable from "./components/PluginsMenu/Nestable/Nestable";
import MainNouiSlider from "./components/PluginsMenu/Noui Slider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/Sweet Alert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/Jqv Map/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

import Institute from "./components/Institute.js";

import Events from "./components/Events.js";
//Tables
import InstituteTable from "./components/tables/InstituteTable";
import UsersTable from "./components/tables/UsersTable";
import PostsTable from "./components/tables/PostsTable";
import PointsTable from "./components/tables/PointsTable";

// Template editor
import TemplateEditor from "./pages/TemplateEditor.js";
import TemplateEditor2 from "./pages/TemplateEditor2.js";
import UserRegistration from "./components/UserRegistration";
import ProtectedRoute from "./components/RouteUtils/ProtectedRoute";

const Markup = () => {
  let path = window.location.pathname;

  //  path = path.split("/");
  //  path = path[path.length - 1];
  //  let pagePath = path.split("-").includes("page");
  path = path.substring(1);
  let pagePath = path.startsWith("page");

  const [activeEvent, setActiveEvent] = useState(!path);

  const routes = [
    /// Dashboard
    { url: "/", component: Home, roles: ["admin", "blog_user"] },
    { url: "projects", component: Projects, roles: ["admin"] },
    { url: "contacts", component: Contacts, roles: ["admin"] },
    { url: "kanban", component: Kanban, roles: ["admin"] },
    { url: "calendar", component: Calendarpage, roles: ["admin"] },
    { url: "messages", component: Messages, roles: ["admin"] },

    // Institute
    { url: "create-institute", component: Institute, roles: ["admin"] },
    { url: "create-user", component: UserRegistration, roles: ["admin"] },

    //tables
    { url: "table-users", component: UsersTable, roles: ["admin"] },
    { url: "table-institutes", component: InstituteTable, roles: ["admin"] },
    { url: "table-posts", component: PostsTable, roles: ["admin"] },
    { url: "table-points", component: PointsTable, roles: ["admin"] },
    { url: "institute-profile/:clientId", component: InstituteProfile, roles: ["admin"] },
    { url: "user-profile/:clientId", component: AppProfile, roles: ["admin"] },
    { url: "events/:eventId", component: Events, roles: ["admin"] },
    //{ url: "companies", component: Companies },
    //{ url: "analytics", component: Analytics },
    //{ url: "review", component: Review },
    //{ url: "order", component: Order },
    //{ url: "order-list", component: Orderlist },
    //{ url: "customer-list", component: Customerlist },

    // Template Editor
    {
      url: "page-template-editor/:clientId",
      component: TemplateEditor2,
      roles: ["admin"],
    },
    {
      url: "page-template-editor/:clientId/:templateId",
      component: TemplateEditor2,
      roles: ["admin"],
    },
    {
      url: "page-template-editor2",
      component: TemplateEditor2,
      roles: ["admin"],
    },

    /// Bootstrap
    { url: "ui-alert", component: UiAlert, roles: ["admin"] },
    { url: "ui-badge", component: UiBadge, roles: ["admin"] },
    { url: "ui-button", component: UiButton, roles: ["admin"] },
    { url: "ui-modal", component: UiModal, roles: ["admin"] },
    { url: "ui-button-group", component: UiButtonGroup, roles: ["admin"] },
    { url: "ui-accordion", component: UiAccordion, roles: ["admin"] },
    { url: "ui-list-group", component: UiListGroup, roles: ["admin"] },
    { url: "ui-media-object", component: UiMediaObject, roles: ["admin"] },
    { url: "ui-card", component: UiCards, roles: ["admin"] },
    { url: "ui-carousel", component: UiCarousel, roles: ["admin"] },
    { url: "ui-dropdown", component: UiDropDown, roles: ["admin"] },
    { url: "ui-popover", component: UiPopOver, roles: ["admin"] },
    { url: "ui-progressbar", component: UiProgressBar, roles: ["admin"] },
    { url: "ui-tab", component: UiTab, roles: ["admin"] },
    { url: "ui-pagination", component: UiPagination, roles: ["admin"] },
    { url: "ui-typography", component: UiTypography, roles: ["admin"] },
    { url: "ui-grid", component: UiGrid, roles: ["admin"] },
    /// Apps
    // { url: "app-profile", component: AppProfile },
    { url: "post-details", component: PostDetails, roles: ["admin"] },
    { url: "email-compose", component: Compose, roles: ["admin"] },
    { url: "email-inbox", component: Inbox, roles: ["admin"] },
    { url: "email-read", component: Read, roles: ["admin"] },
    { url: "app-calender", component: Calendar, roles: ["admin"] },
    /// Shop
    { url: "ecom-product-grid", component: ProductGrid, roles: ["admin"] },
    { url: "ecom-product-list", component: ProductList, roles: ["admin"] },
    { url: "ecom-product-detail", component: ProductDetail, roles: ["admin"] },
    { url: "ecom-product-order", component: ProductOrder, roles: ["admin"] },
    { url: "ecom-checkout", component: Checkout, roles: ["admin"] },
    { url: "ecom-invoice", component: Invoice, roles: ["admin"] },
    { url: "ecom-product-detail", component: ProductDetail, roles: ["admin"] },
    { url: "ecom-customers", component: Customers, roles: ["admin"] },

    /// Chart
    { url: "chart-sparkline", component: SparklineChart, roles: ["admin"] },
    { url: "chart-float", component: ChartFloat, roles: ["admin"] },
    { url: "chart-chartjs", component: ChartJs, roles: ["admin"] },
    { url: "chart-chartist", component: Chartist, roles: ["admin"] },
    { url: "chart-btc", component: BtcChart, roles: ["admin"] },
    { url: "chart-apexchart", component: ApexChart, roles: ["admin"] },
    { url: "chart-rechart", component: RechartJs, roles: ["admin"] },

    /// table
    { url: "table-datatable-basic", component: DataTable, roles: ["admin"] },
    { url: "table-bootstrap-basic", component: BootstrapTable, roles: ["admin"] },

    /// Form
    { url: "form-element", component: Element, roles: ["admin"] },
    { url: "form-wizard", component: Wizard, roles: ["admin"] },
    { url: "form-wizard", component: Wizard, roles: ["admin"] },
    { url: "form-editor-summernote", component: SummerNote, roles: ["admin"] },
    { url: "form-pickers", component: Pickers, roles: ["admin"] },
    { url: "form-validation-jquery", component: jQueryValidation, roles: ["admin"] },

    /// Plugin

    { url: "uc-select2", component: Select2, roles: ["admin"] },
    { url: "uc-nestable", component: Nestable, roles: ["admin"] },
    { url: "uc-noui-slider", component: MainNouiSlider, roles: ["admin"] },
    { url: "uc-sweetalert", component: MainSweetAlert, roles: ["admin"] },
    { url: "uc-toastr", component: Toastr, roles: ["admin"] },
    { url: "map-jqvmap", component: JqvMap, roles: ["admin"] },
    { url: "uc-lightgallery", component: Lightgallery, roles: ["admin"] },

    /// pages
    { url: "widget-basic", component: Widget, roles: ["admin"] },
    { url: "page-institute", component: InstituteRegistration, roles: ["admin"] },
    { url: "page-register", component: Registration, roles: ["admin"] },
    { url: "page-lock-screen", component: LockScreen, roles: ["admin"] },
    { url: "page-login", component: Login, roles: ["admin"] },
    { url: "page-error-400", component: Error400, roles: ["admin"] },
    { url: "page-error-403", component: Error403, roles: ["admin"] },
    { url: "page-error-404", component: Error404, roles: ["admin"] },
    { url: "page-error-500", component: Error500, roles: ["admin"] },
    { url: "page-error-503", component: Error503, roles: ["admin"] },
    { url: "page-forgot-password", component: ForgotPassword, roles: ["admin"] },
  ];

  return (
    <Router>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}`}
      >
        {!pagePath && (
          <Nav
            onClick={() => setActiveEvent(!activeEvent)}
            activeEvent={activeEvent}
            onClick2={() => setActiveEvent(false)}
            onClick3={() => setActiveEvent(true)}
          />
        )}

        <div
          className={` ${!path && activeEvent ? "rightside-event" : ""} ${
            !pagePath ? "content-body" : ""
          }`}
        >
          <div className={`${!pagePath ? "container-fluid" : ""}`}>
            <Switch>
              {routes.map((data, i) => (
                <ProtectedRoute
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
				  roles={data.roles}
                >
					{data.component}
				</ProtectedRoute>
              ))}
            </Switch>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
    </Router>
  );
};

export default Markup;
